// @flow

import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { HashLink as Link } from 'react-router-hash-link'
import { withRouter } from 'react-router-dom'
import { UilAngleRightB } from '@iconscout/react-unicons'
import { fetchArticlesData } from '../../actions/learn'

type Props = {
  globalGetLanguages: string,
  articlesData: any,
  articlesDataError: boolean,
  fetchArticlesData: () => void,
  history: any,
  closeDropdown?: () => void
}

const DropdownTalentMg = ({ globalGetLanguages, articlesData, articlesDataError, fetchArticlesData, history, closeDropdown }: Props) => {
  const [activeSection, setActiveSection] = useState('programs')
  const [apiData, setApiData] = useState({
    tm_solution: null
  })

  // Fetch API data on component mount
  useEffect(() => {
    fetchArticlesData()
  }, [fetchArticlesData])

  // Update local state when Redux data changes
  useEffect(() => {
    if (articlesData && articlesData.size > 0) {
      const articlesDataJS = articlesData.toJS()
      if (articlesDataJS.tm_solution) {
        setApiData({ tm_solution: articlesDataJS.tm_solution })
      }
    }
  }, [articlesData])

  // Define content for each section
  const contentSections = {
    programs: {
      leftColumn: {
        title: null,
        links: [
          { to: '/nextgen-assessment-center?utm_content=talent-management', text: 'NextGen Assessment Center' },
        ]
      },
      rightColumn: {
        title: null,
        links: [
          { to: '/talent-management/internal-mobility', text: 'Internal Mobility' },
          { to: '/talent-management/talent-mapping', text: 'Talent Mapping' },
          { to: '/talent-management/succession-planning', text: 'Succession Planning' },
          { to: '/talent-management/high-potential-identification', text: 'High Potential Identification' },
        ]
      }
    }
  }

  const currentContent = contentSections[activeSection]

  return (
        <section>
          <li className="head-drop-page-link">
            <a 
              className={activeSection === 'programs' ? 'active' : ''}
              onMouseEnter={() => setActiveSection('programs')}
            >
              Solutions & Use Cases <UilAngleRightB/>
            </a>
          </li>
          <li className="link-middle">
            {currentContent.leftColumn.title && <h2>{currentContent.leftColumn.title}</h2>}
            {currentContent.leftColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          <li className="link-middle">
            {currentContent.rightColumn.title ? 
              <h2>{currentContent.rightColumn.title}</h2> : 
              (activeSection === 'campus' ? <h2>&nbsp;</h2> : null)
            }
            {currentContent.rightColumn.links.map((link, index) => (
              <Link key={index} to={link.to}>{link.text}</Link>
            ))}
          </li>
          {apiData.tm_solution != null && (
            <li className="link-with-img" onClick={() => {
              history.push(`/learn-detail/${apiData.tm_solution.id}`)
              if (closeDropdown) closeDropdown()
            }}>
              <img src={apiData.tm_solution.image_url} alt={apiData.tm_solution.title} />
              <h4>{apiData.tm_solution.title}</h4>
              <p>{apiData.tm_solution.desc}</p>
            </li>
          )}
        </section>
  )
}

const mapStateToProps = (state) => ({
  articlesData: state.articlesData,
  articlesDataError: state.articlesDataError
})

const mapDispatchToProps = {
  fetchArticlesData
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(DropdownTalentMg))